// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-sms-users-dialog .fi-user-list {
  padding: 0;
}
.fi-sms-users-dialog .fi-user-list .mat-mdc-card {
  box-shadow: none;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/sms/fi-sms-users-dialog/fi-sms-users-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,UAAA;AAAR;AACQ;EACI,gBAAA;EACA,UAAA;AACZ","sourcesContent":[".fi-sms-users-dialog {\r\n    .fi-user-list {\r\n        padding: 0;\r\n        .mat-mdc-card {\r\n            box-shadow: none;\r\n            padding: 0;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
